// this file added by Bearer Web Developer
import { Button } from "@mui/material";
import styles from './editOriginLocation.module.scss';
import React from "react";
import { useAppState } from "../../../../states/app-state";
import { observer } from "mobx-react-lite";
import { useThemeMode } from "../../../../states/contexts/theme";

const EditOriginLocation: React.FC = observer(() => {

    const appState = useAppState();
    const { setDefaultOriginFormOpen } = appState.favouritePlaces;
    const handleDefaultOriginForm = () => {
        // open defaultOriginForm
        setDefaultOriginFormOpen(true)
    };
    const { theme } = useThemeMode(); // added by Bearer Web Developer
    // modified by Bearer Web Developer start
    return (
        <>

            <div className={styles.favourite_place} onClick={handleDefaultOriginForm} data-theme={theme}> {/* data-theme property added by Bearer Web Developer */}
                <div className={styles.favourite_place_info}>
                    <div className={styles.location_favourite_place}>
                       {theme === 'dark' ? <img src="/edit-location-white.svg" alt="edit" /> : <img src="/edit_location.svg" alt="edit" />}
                    </div>
                    <div className={styles.list_item_text}>
                        <h6>Set your default origin location</h6>
                        <p>Click here to add the address</p>
                    </div>
                </div>
                <Button>
                    {theme === 'dark' ? <img src="/edit-white.svg" alt="edit" /> : <img src="/edit_location_pen.png" alt="edit" />}
                </Button>
            </div>
        </>
    )
    // modified by Bearer Web Developer end
})
export default EditOriginLocation;